import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useProp103 } from './useFeatureFlag';
import { getFeatureFlagFromStorage } from '../utils/featureFlags.utils';

const PROP_103_STATES_ABVR = ['CA'];
/**
 * Validates if the current rate state should behave with the prop 103 feature
 * @returns {boolean}
 */
export const useProp103Features = () => {
  const prop103FF = useProp103();
  const rateData = useSelector(({ quoting }) => quoting.data);

  const isStateWithProp103 = useMemo(
    () => PROP_103_STATES_ABVR.includes(rateData?.stateAbrv),
    [rateData],
  );

  return prop103FF && isStateWithProp103;
};

export const isProp103FeaturesForActions = (state) => {
  const { CrossAppProp103: prop103FF } = getFeatureFlagFromStorage();
  const isStateWithProp103 = PROP_103_STATES_ABVR.includes(state);
  return prop103FF && isStateWithProp103;
};
